interface InfoCardProps {
  label: string;
  value?: string | number | null;
  bgColor?: string;
  textColor?: string;
}

export default function InfoCard({
  label,
  value = "---",
  bgColor = "bg-success-50",
  textColor = "text-success-700",
}: InfoCardProps) {
  return (
    <article className={`${bgColor} rounded-lg p-4 px-6 flex flex-col gap-2`}>
      <h3 className={`${textColor} text-xl font-semibold`}>{label}</h3>
      <p className="flex justify-end items-end text-neutral-400 text-2xl font-medium">
        {value}
      </p>
    </article>
  );
}
